import { SERVICE_NAME } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import ServiceNamePage from "./container/ServiceNamePage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: SERVICE_NAME,
    withSidebar: true,
    withAppBar: true,
    component: ServiceNamePage,
  };
}
